import DeclaracaoEspecifica from './declaracaoEspecifica';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import {
  changeDeclaracaoPFValueForm,
  changeDeclaracaoPJValueForm,
  handleChangeDeclaracaoSouPessoaFlag,
  handleChangeDeclaracaoRelacionamentoFlag,
  handleChangeDeclaracaoSocioFlag,
  handleChangeDeclaracaoFatcaFlag,
  handleChangeDeclaracaoPersonFlag,
  handleChangeDeclaracaoOperacaoImportacao,
  changeDeclaracaoNIF,
  handleChangeDadosNIFCountry,
  handleChangeDadosRendaMensal,
  handleChangeDadosPatrimonio,
  fillProfessionList,
  changeProfession,
  getListDeclaracaoAnualAction,
  handleChangeDeclaracaoAnual
} from '../../store/declaracaoEspecifica/actions';

import {
  getListRendaMensalAction,
  getListPatrimonioAction
} from '../../store/rendaPatrimonio/actions';

import { configuracaoDdi } from '../../store/ddi/actions';

const mapStateToProps = (state, nextState) => ({
  declaracaoEspecifica: state.declaracaoEspecificaReducer,
  possuiDomicilioFiscalEUA: state.dadosComplementaresReducer.dadosComplementares_pessoaAmericana,
  ddi: state.ddiReducer,
  rendaPatrimonio: state.rendaPatrimonioReducer
});

const mapDispatchToProps = dispatch =>
  bindActionCreators({
    changeDeclaracaoPFValueForm,
    changeDeclaracaoPJValueForm,
    handleChangeDeclaracaoSouPessoaFlag,
    handleChangeDeclaracaoRelacionamentoFlag,
    handleChangeDeclaracaoSocioFlag,
    handleChangeDeclaracaoFatcaFlag,
    handleChangeDeclaracaoPersonFlag,
    handleChangeDeclaracaoOperacaoImportacao,
    changeDeclaracaoNIF,
    handleChangeDadosNIFCountry,
    configuracaoDdi,
    handleChangeDadosRendaMensal,
    handleChangeDadosPatrimonio,
    getListRendaMensalAction,
    getListPatrimonioAction,
    fillProfessionList,
    changeProfession,
    getListDeclaracaoAnualAction,
    handleChangeDeclaracaoAnual
  }, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DeclaracaoEspecifica);